import React, {useRef} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/pro-light-svg-icons';
import {toast} from 'react-toastify';
import {
  Modal,
} from '@mayo/mayo-ui-gakki';

function CopyForm({
  value,
  title,
  isLoading = false,
  onClose,
  isOpen = false,
}: {
  value: string | React.ReactNode;
  title: string;
  isLoading?: boolean;
  onClose: () => void;
  isOpen?: boolean;
}) {
  const paragraph = useRef<HTMLParagraphElement>(null);
  const toastId = 'copy-toast';
  return (
    <>
      <Modal
        modalLabel="copy-dialog"
        isOpen={isOpen}
        size="sm"
        modalTitle={title}
        onTitleClose={onClose}
        onConfirm={onClose}
        hideFooter
      >
        {isLoading && <div>Loading</div>}
        {!isLoading && (
          <p
            ref={paragraph}
            className={'h-full p-4 relative break-all bg-brand-gray'}
            onClick={() => {
              if (paragraph.current) {
                let range = document.createRange();
                let selection = window.getSelection();
                range.selectNodeContents(paragraph.current);
                selection?.removeAllRanges();
                selection?.addRange(range);
                document.execCommand('copy');
                toast.info('已複製', {
                  delay: 200,
                  hideProgressBar: true,
                  position: 'top-center',
                  toastId,
                });
              }
            }}
          >
            {value}
            <FontAwesomeIcon
              icon={faCopy}
              className={'absolute text-brand right-1 bottom-1'}
            />
          </p>
        )}
      </Modal>
    </>
  );
}

export default CopyForm;
